import { useState } from 'react';
import { LatLongIcon } from '@rsos/assets/icons';
import { Box, Select, Text } from '@rsos/base-components';
import { TranslationLanguage } from '@rsos/reduxDataStore/src/features/chats/chatsTypes';
import { IconButton } from '../SharedChatUI/IconButton';
import {
  LanguageOption,
  useTranslationLanguageOptions,
} from '../SharedChatUI/useTranslationLanguageOptions';

type Props = {
  selectedLanguage: TranslationLanguage | null;
  onLanguageSelect: (language: TranslationLanguage | null) => void;
};

export const TF911InitiationTranslationMenu = ({
  selectedLanguage,
  onLanguageSelect,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const options = useTranslationLanguageOptions();
  const selectedOption = selectedLanguage
    ? (options.find(o => o.value === selectedLanguage.languageCode) ?? null)
    : null;

  return (
    <>
      <IconButton
        data-name="tf911-initiation-translation-button"
        title="Translation menu"
        active={isOpen || !!selectedLanguage}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <LatLongIcon width={14} height={14} color="secondaryText" />
      </IconButton>
      {isOpen && (
        <Box
          p="8px"
          justify="center"
          alignSelf="stretch"
          borderRadius="5px"
          border="1px solid"
          borderColor="lightLineDivider"
          bg="foreground"
          color="secondaryText"
          flow={16}
        >
          <label style={{ fontWeight: 'normal' }}>
            <Text size="small">Citizen language:</Text>
          </label>
          <Select
            options={options}
            value={selectedOption}
            onChange={(v: LanguageOption | null) =>
              onLanguageSelect(v?.data ?? null)
            }
            isClearable
          />
        </Box>
      )}
    </>
  );
};
